export default __webpack_public_path__ + "assets/facebook.c017b941.svg";